module.exports = __webpack_public_path__ + "img/Tainan_art.8a50295c.jpg";